import {
  AlertIcon,
  Button,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
} from '@chakra-ui/react'
import React, { useContext } from 'react'
import { HiUserGroup } from 'react-icons/hi'
import { BiUser } from 'react-icons/bi'
import { FaRegHandshake } from 'react-icons/fa'
import { RiFileList2Fill, RiUser3Line, RiUser6Line } from 'react-icons/ri'
import { useDispatch } from 'react-redux'
import { userContext } from '../../context'
import { UPDATE_PROFILE } from '../../redux/constants'
import './style.css'
import { GrShieldSecurity } from 'react-icons/gr'
import { Link } from 'react-router-dom'

export default function Navbar() {
  const dispatch = useDispatch()
  const { userData, setUserData } = useContext(userContext)
  const logout = () => {
    try {
      localStorage.clear()
      setUserData(null)
      dispatch({
        type: UPDATE_PROFILE,
        payload: null,
      })
    } catch (error) {
      console.log(error)
    }
  }
  return (
    <nav class="navbar navbar-expand-lg border-b lg:py-2  navbar-light ">
       
      <div class="container md:w-3/4">
        <Link to="/">
          {' '}
          <img
            class="navbar-brand w-24"
            alt="logo"
            src={'../images/logoh.svg'}
          />
        </Link>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
          <ul class="navbar-nav  ml-auto mb-2 mb-lg-0">
            <li class="nav-item lg:text-2xl">
              <Link class="nav-link px-2" to="/">
                A propos
              </Link>
            </li>{' '}
            <li class="nav-item had lg:text-2xl">
              <Link class="nav-link  px-2" to="/how">
                Comment ca marche{' '}
              </Link>
            </li>{' '}
            {userData ? (
              <>
                {userData.roles === 'Admin' ? (
                  <Menu>
                    <MenuButton
                      as={Button}
                      className="border bg-white focus:shadow-none focus:border-none  text-green-400"
                      rightIcon={<RiUser3Line />}
                    >
                      Admin{' '}
                    </MenuButton>
                    <MenuList>
                      <MenuItem>
                        {' '}
                        <a
                          href="/profil"
                          className="font-bold flex align-items-center gap-2"
                        >
                          <RiUser6Line />
                          Mon Profil{' '}
                        </a>
                      </MenuItem>
                      <MenuItem>
                        <Link
                          to="/my.admin"
                          className="font-bold flex align-items-center gap-2"
                        >
                          <GrShieldSecurity /> Administration{' '}
                        </Link>
                      </MenuItem>
                      <MenuItem>
                        {' '}
                        <a
                          href="/my.service"
                          className="font-bold flex align-items-center gap-2"
                        >
                          <RiFileList2Fill /> Commandes{' '}
                        </a>
                      </MenuItem>
                      <MenuItem>
                        {' '}
                        <a
                          href="/my.user"
                          className="font-bold flex align-items-center gap-2"
                        >
                          <HiUserGroup /> Utilisateurs{' '}
                        </a>
                      </MenuItem>
                      <MenuItem>
                        {' '}
                        <a
                          href="/my.friend"
                          className="font-bold flex align-items-center gap-2"
                        >
                          <FaRegHandshake /> Partenaires
                        </a>
                      </MenuItem>
                      <MenuItem>
                        <hr />
                      </MenuItem>
                      <MenuItem>
                        {' '}
                        <button
                          onClick={logout}
                          className="text-danger hover:bg-light border rounded py-1 text-center btn-block hover:border font-bold text-sm w-100 "
                        >
                          Déconnexion{' '}
                        </button>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                ) : (
                  <Menu>
                    <MenuButton
                      as={Button}
                      className="border bg-white focus:shadow-none focus:border-none  text-info"
                      rightIcon={<RiUser6Line />}
                    >
                      {userData.name ? userData.name : 'Profile'}{' '}
                    </MenuButton>
                    <MenuList>
                      <MenuItem>
                        {' '}
                        <a href="/profil" className="font-bold">
                          Mon Profil{' '}
                        </a>
                      </MenuItem>
                      <MenuItem>
                        <hr />
                      </MenuItem>
                      <MenuItem>
                        {' '}
                        <button
                          onClick={logout}
                          className="text-danger hover:bg-light border rounded py-1 text-center btn-block hover:border font-bold text-sm w-100 "
                        >
                          Déconnexion{' '}
                        </button>
                      </MenuItem>
                    </MenuList>
                  </Menu>
                )}
              </>
            ) : (
              <li class="nav-item head   lg:text-2xl">
                <a className="nav-link hover:text-black-400 bg-orange-400 text-white btn rounded items-center" href="/se-connecter">
                   Se connecter
                </a>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  )
}
